import React from 'react'
import { connect } from 'react-redux'
import { projectsLoadRequest } from '../../actions'
import { PostsList } from 'components/Layout'
import { Button } from 'components/Button'

class ProjectListContainer extends React.Component {
	componentWillMount() {
		this.props.requestProjects()
	}
	render() {
		return (
			<PostsList
				header={'LiveChat Projects'}
				info={
					<a
						href="https://developers.livechatinc.com/projects/"
						target="_blank"
						rel="noopener"
					>
						<Button>See all</Button>
					</a>
				}
				posts={this.props.projects || []}
			/>
		)
	}
}

const mapStateToProps = (state, ownProps) => ({
	projects: state.projects.items
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	requestProjects: () => {
		dispatch(projectsLoadRequest())
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(
	ProjectListContainer
)



// WEBPACK FOOTER //
// ./src/containers/ProjectList/ProjectList.js